// extracted by mini-css-extract-plugin
export var table = "_xk-0";